import * as tslib_1 from "tslib";
import { UiForm } from '@swim/ui';
var GeometryForm = (function (_super) {
    tslib_1.__extends(GeometryForm, _super);
    function GeometryForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GeometryForm;
}(UiForm));
export { GeometryForm };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VvbWV0cnktZm9ybS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImdlb21ldHJ5LWZvcm0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxNQUFNLEVBQUMsTUFBTSxVQUFVLENBQUM7QUFJaEM7SUFBNEYsd0NBQVk7SUFBeEc7O0lBRUEsQ0FBQztJQUFELG1CQUFDO0FBQUQsQ0FBQyxBQUZELENBQTRGLE1BQU0sR0FFakcifQ==